// eslint-disable-next-line import/prefer-default-export
export const appGetters = {
    sidebarStatus: (state) => state.sidebarStatus,
    isLoading: (state) => state.loading > 0,
    appTitle: (state) => state.appTitle,
    constants: (state) => state.constants,
    lang_code: (state) => state.lang_code,
};
